import { ModelMapper } from "@api/mappers/mappers.types";
import { SearchItem, SearchItemType } from "@components/Store/StoreSearchInput/storeSearchInput.types";

export const storeFeatureMapper: ModelMapper<
    woosmap.map.stores.StoreResponse,
    SearchItem
> = store => {
    return {
        value: store.properties.user_properties.storeId,
        label: store.properties.name,
        type: SearchItemType.Store,
    };
};
